OE.addPlugin('Slider', (function(){

    var Plugin = {},
        Options = {
            autoplay : false
        },
        dataAttributeName = 'data-oe-slider',
        timerVar = 'autoplay_timer';

    Plugin.init = function()
    {
        var sliders = getSlider(),
            slider_count = sliders.length;

        for(var i = 0; i < slider_count; i++ )
        {
            var slider = sliders[i];

            if(slider.initialized)
            {
                // ignore all sliders that are already initialized
                continue;
            }

            // add AutoPlay
            autoPlay.bind(slider)();

            // mark this slider as 'initialized'
            slider.initialized = true;


            // stop and restart autoplay whenever the slider is navigated manually -
            // add a delegated event on each INPUT element when they change
            var inputs = slider.querySelectorAll( 'input' ),
                input_count = inputs.length;

            for(var j = 0; j < input_count; j++)
            {
              inputs[j].addEventListener( 'change', autoPlay );
              inputs[j].addEventListener( 'change', Plugin.updateSliderPlayingState );
            }
        }
    };

    Plugin.Pause = function(element)
    {
        var slider = getSliderElementFor(element); // the name of the timer variable
        if(slider)
        {
            try { OE.$win.clearTimeout(slider[timerVar]); } catch(ev) {  }
        }
    };

    Plugin.Play = function(element)
    {
        var slider = getSliderElementFor(element); // the name of the timer variable
        if(slider)
        {
            autoPlay.bind(slider)();
        }
    };

    /**
     * Adds a timeout on the slider that will trigger the nextSlide function
     * after X seconds - if the option AUTOPLAY is set to a value > 0.
     */
    var autoPlay = function()
    {
        var slider = getSliderElementFor(this), // get corresponding slider element to THIS
            options = getOptionsFor(slider), // get slider options
            seconds = parseInt(options.autoplay) * 1000; // AUTOPLAY options is false or number of seconds a slide is visible

        // clear any existing timeout
        try { OE.$win.clearTimeout(slider[timerVar]); } catch(ev) {  }

        if(seconds > 0)
        {
            // autoplay option is set to a value > 0,
            // add the timeout.
            slider[timerVar] = OE.$win.setTimeout(
                nextSliderAuto.bind(slider),
                seconds
            );
        }
    };

    var nextSliderAuto = function() {
      if( !isCurrentSlidePlaying(this) )
      {
        nextSlide.bind( this )();
      }
    };

    /**
     * Will navigate to the next slide
     */
    var nextSlide = function()
    {
        var slider = getSliderElementFor(this), // get corresponding slider element to THIS
            input = slider.querySelector('input:checked'), // get current checked input field (active slide)
            inputs = slider.querySelectorAll('input'), // get all INPUT fields (all slides)
            input_count = inputs.length, // store the number of INPUT fields
            next_input; // will store the next input field (next slide)

        if(input)
        {
            // a CHECKED input field is found...
            for(var i = 0; i < input_count; i++ )
            {
                // walk through all input fields...
                if(inputs[i] === input)
                {
                    // the current input field in the list is the current CHECKED input field,
                    if(i < inputs.length-1)
                    {
                        // there is at least 1 'next' input field,
                        // this will be the next one.
                        next_input = inputs[i + 1];

                        // break the loop
                        break;
                    }
                }
            }

            if(typeof next_input === 'undefined')
            {
                // no next input field is found, let's select the first in the list
                next_input = inputs[0];
            }
        }

        if(typeof next_input !== 'undefined')
        {
            // a next input field was set
            if(next_input !== input)
            {
                // the next input is not the same as the current one
                input.checked = false; // uncheck the current INPUT (slide)
                next_input.checked = true; // check the next INPUT (slide)
                OE.Utils.triggerEvent(next_input, 'change'); // trigger any change event
            }
        }

        // restart the AUTOPLAY timer
        autoPlay.bind(slider)();
    };

    var isCurrentSlidePlaying = function( e ) {

      var is_event = e instanceof Event,
          element = is_event ? this : e;

      var slider = getSliderElementFor(element); // the name of the timer variable
      if(slider)
      {
        return slider.querySelector('input:checked + label + div.is--playing' ) ? true : false;
      }

      return false;
    };

    Plugin.updateSliderPlayingState = function( e ) {

      var is_event = e instanceof Event,
          element = is_event ? this : e;


      var slider = getSliderElementFor(element); // the name of the timer variable
      if(slider)
      {
        if( isCurrentSlidePlaying( element ) )
        {
          slider.classList.add('is--playing');
        }
        else
        {
          slider.classList.remove('is--playing');
        }
      }


    };

    /**
     * Get the corresponding slider element for the given {element}.
     * @param  {Node} element The element within the slider or the slider itself
     * @return {Node (list)}  The slider element that holds all slides or if {element} is not given all slider elements within the current DOM
     */
    var getSlider = function(element)
    {
        if(typeof element === 'undefined')
        {
            // if {element} is not set return all found slider elements within the document
            return document.querySelectorAll('[' + dataAttributeName + ']');
        }
        else
        {
            // return the corresponding slider for {element}
            return getSliderElementFor(element);
        }
    };

    /**
     * Returns the corresponding slider element for the given {element}.
     * @param  {Node} element       The element within the slider or the slider itself
     * @return {Node | undefined}   The slide element (or UNDEFINED if no slider is found)
     */
    var getSliderElementFor = function(element)
    {

        // if any element is given and it can have an attribute and it does not have a {dataAttributeName} attribute
        while (element && typeof element.hasAttribute === 'function' && !element.hasAttribute(dataAttributeName))
        {
            // get its parent element
            element = element.parentElement;
        }

        return element;
    };

    /**
     * Returns the options for a fiven slider relement
     * @param  {Node} element The slider element
     * @return {Object}       The option for the slider (merged with the default options)
     */
    var getOptionsFor = function(element)
    {
        return OE.Utils.getOptionsFromString(Options, element.getAttribute(dataAttributeName));
    };

    // return the plugin
    return Plugin;
})());
